module.exports = __webpack_public_path__ + "img/QLD.4f34c3b6.png";